<template>
  <div>
    <button class="color-picker-button" :style="{ backgroundColor: internalColor, height: height + 'px', width: height + 'px' }" @click="triggerColorPicker">
      <span class="material-icons " :style="{ fontSize: height * 0.5 + 'px' }">colorize</span>
      <input type="color" v-model="internalColor" @input="updateColor" ref="colorPicker" hidden />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: '#ffffff' // Default color value
    },
    height: {
      type: Number,
      default: 40 // Default height
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      internalColor: this.modelValue // Sync with modelValue
    }
  },
  watch: {
    modelValue(newValue) {
      this.internalColor = newValue // Update internal color when modelValue changes
    }
  },
  methods: {
    updateColor() {
      this.$emit('update:modelValue', this.internalColor) // Emit update:modelValue event
    },
    triggerColorPicker() {
      this.$refs.colorPicker.click() // Trigger click event on color input
    }
  }
}
</script>

<style scoped>
.color-picker-button {
  border: none;
  cursor: pointer;
  padding: 10px;
  border-radius: 5px;
  color: black;
}
</style>